import { render } from "./Color.vue?vue&type=template&id=4b822693&scoped=true"
import script from "./Color.vue?vue&type=script&lang=ts"
export * from "./Color.vue?vue&type=script&lang=ts"

import "./Color.vue?vue&type=style&index=0&id=4b822693&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4b822693"

export default script